module.exports = __webpack_public_path__ + "img/ph-bottom.0109553b.png";